var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRescue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5r4tr1wq1a",
    d: "M0.648 0.779L28 0.779 28 9.353 0.648 9.353z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9txgodoo0c",
    d: "M0 0.635L25.342 0.635 25.342 13.999 0 13.999z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(0 2.365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sb72tm5vlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5r4tr1wq1a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M1.945 9.353v-.005h-.127c-.646 0-1.17-.525-1.17-1.17v-.024c0-.646.524-1.17 1.17-1.17h4.385c.188-.079.32-.264.32-.48V5.17c0-.287-.233-.52-.52-.52H4.218c.506-.465 1.038-.904 1.6-1.314L8.13 2.89 10.24.78h5.297v.834l2.874 2.734h3.638l2.552-2.875h3.061L26.23 3.833 28 5.603l-2.574 2.573h-1.689l-1.883-1.882h-1.636l-5.376 3.06H1.945zM12.518 7.52V6.288h1.231V5.171h-1.23V3.94H11.4v1.232H10.17v1.117h1.232V7.52h1.117zm13.534-1.837c0-.789-.64-1.43-1.43-1.43-.79 0-1.43.641-1.43 1.43 0 .79.64 1.431 1.43 1.431.79 0 1.43-.64 1.43-1.43zm-2 0c0-.314.255-.57.57-.57.314 0 .57.256.57.57 0 .315-.256.57-.57.57-.315 0-.57-.255-.57-.57z",
    mask: "url(#sb72tm5vlb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(0 .365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ivsy3icped",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9txgodoo0c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M3.34 13.94l-.017-.008h-.001v-.002H3.32l-.009-.005c-.015-.01-.02-.014 0 0l.007.003c-.058-.037-.057-.037-.043-.029l-.036-.027c-.014-.011-.025-.022-.03-.027l-.004-.005-.519-.52c-.195-.194-.203-.504-.018-.688h.001c.185-.187.494-.178.69.017l.4.4h2.893v-1.01h.95v1.01h4.752v-1.01h.95v1.01h2.894c.276 0 .5.213.5.476 0 .261-.224.474-.5.474H3.58c-.104 0-.2-.029-.24-.06zm7.43-11.721v-.317H.5c-.276 0-.5-.212-.5-.475C0 1.165.224.95.5.95h10.512c.143-.196.338-.317.554-.317h2.21c.214 0 .41.121.553.318h10.512c.276 0 .501.213.501.475s-.225.474-.5.474h-10.27v.318H10.77z",
    mask: "url(#ivsy3icped)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescue);
export default __webpack_public_path__ + "static/media/rescue.ff07ef9cee8e6465a3f585923a3440db.svg";
export { ForwardRef as ReactComponent };